import { render, staticRenderFns } from "./inviteFriends.vue?vue&type=template&id=dd4333c2&scoped=true&"
import script from "./inviteFriends.vue?vue&type=script&lang=js&"
export * from "./inviteFriends.vue?vue&type=script&lang=js&"
import style0 from "./inviteFriends.vue?vue&type=style&index=0&id=dd4333c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4333c2",
  null
  
)

export default component.exports